export default {
  computed: {
    therms() {
      return this.$store.getters.get_therm.sort((a, b) => a.position - b.position);
    },
    ext_therms() {
      return this.$store.getters.get_ext_therm;
    },
  },
};
